<template>
  <div class="presupuesto-print">
    <img src="../../assets/contenido/banner-print.jpg">
    <br><br><br>
    <div class="davi-curs title-print">Presupuesto Mensual</div>
    <!-- Ingresos -->
    <div class="title-print-two span-red">Ingresos</div>

    <table class="form-calculadora">
      <tr class="form-titles">
        <th colspan="2">
          <span class="span-red davi-curs">Activos</span>
        </th>
        <th class="font-red davi-curs">
          <span class="span-red davi-curs">Valor</span>
        </th>
      </tr>
      <template v-for="item in patrimonioActivo">
        <tr class="tr-space"></tr>
        <tr v-for="(itemInt, indexInt) in item.valores" :class="indexInt===0?'tr-header':''">
          <td v-if="indexInt === 0" :rowspan="item.valores.length">
              <div class="title-row font-red"><span class="span-red davi-curs">{{item.nombre}}</span></div>
          </td>
          <td class="text-xs-right">
            <p>{{itemInt.desc}}</p>
          </td>
          <td class="input-td">
            <div class="valor">
              <template v-if="itemInt.valor"> ${{itemInt.valor}} </template>
              <template v-if="!itemInt.valor"> ${{0}} </template>
            </div>
          </td>
        </tr>
      </template>
      <tr>
        <td colspan="2" class="text-xs-right"> <span class="span-red davi-curs">Total activo</span></td>
        <td class="input-td">
          <strong><span class="span-red davi-curs">${{patrimonioTotalActivos}}</span></strong>
        </td>
      </tr>
    </table>

    <!-- Pasivos -->
    <div class="html2pdf__page-break"></div>
    <table class="form-calculadora">
      <tr class="form-titles">
        <th colspan="2">
          <span class="span-red davi-curs">Pasivos</span>
        </th>
        <th class="font-red davi-curs">
          <span class="span-red davi-curs">Valor</span>
        </th>
      </tr>
      <template v-for="item in patrimonioPasivo">
        <tr class="tr-space"></tr>
        <tr v-for="(itemInt, indexInt) in item.valores" :class="indexInt===0?'tr-header':''">
          <td v-if="indexInt === 0" :rowspan="item.valores.length">
              <div class="title-row font-red"><span class="span-red davi-curs">{{item.nombre}}</span></div>
          </td>
          <td class="text-xs-right">
            <p>{{itemInt.desc}}</p>
          </td>
          <td class="input-td">
            <div class="valor">
              <template v-if="itemInt.valor"> ${{itemInt.valor}} </template>
              <template v-if="!itemInt.valor"> ${{0}} </template>
            </div>
          </td>
        </tr>
      </template>
      <tr>
          <td colspan="2" class="text-xs-right font-red davi-curs"><span class="span-red davi-curs">Total activo</span></td>
          <td class="input-td"><strong><span class="span-red davi-curs">${{patrimonioTotalActivos}}</span></strong></td>
        </tr>
        <tr>
          <td colspan="2" class="text-xs-right font-red davi-curs"><span class="span-red davi-curs">Menos (-) Total pasivo</span></td>
          <td class="input-td"><strong><span class="span-red davi-curs">${{patrimonioTotalPasivos}}</span></strong></td>
        </tr>
        <tr>
          <td colspan="2" class="text-xs-right"><p class="davi-curs"><span class="span-red davi-curs">Patrimonio</span></p></td>
          <td class="input-td"><strong><span class="span-red davi-curs">${{diferenciaPatrimonio}}</span></strong></td>
        </tr>
    </table>

  </div>
</template>

<script>
export default {
  data() {
    return {
      nombresUno: [
        {
          parteUno: "Ingreso por salario mensual",
          parteDos: ""
        },
        {
          parteUno: "Valor real,",
          parteDos: "(Lo efectivamente recibido durante el mes)"
        },
        {
          parteUno: "Valor planeado,",
          parteDos: "(El esperado inicialmente en el presupuesto mensual)"
        },
        {
          parteUno: "Diferencia mensual",
          parteDos: ""
        }
      ],
      nombresDos: ["Valor real", "Valor planeado", "Diferencia mensual"]
    };
  },
  computed: {
    patrimonioActivo() {
      return this.$store.state.patrimonioActivo;
    },
    patrimonioPasivo() {
      return this.$store.state.patrimonioPasivo;
    },
    patrimonioTotalActivos() {
      return this.$store.getters.patrimonioTotalActivos;
    },
    patrimonioTotalPasivos() {
      return this.$store.getters.patrimonioTotalPasivos;
    },
    diferenciaPatrimonio() {
      return this.$store.getters.diferenciaPatrimonio;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";

.presupuesto-print {
  padding: 10px 50px;
  .title-print {
    font-size: 30px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .title-print-two {
    font-size: 25px;
    font-weight: bold;
  }
  img {
    width: 100%;
  }
  .span-red {
    color: $secondary-red !important;
  }
  .valor {
    border: solid 1px $secondary-red;
    text-align: center;
    font-weight: bold;
  }
  .valor-total {
    text-align: center;
    font-weight: bold;
    color: $secondary-red;
  }
}
.form-calculadora {
  width: 100%;
  margin: 5px auto;
  border-collapse: collapse;
  padding: 10px;
  .form-titles {
    border-bottom: solid 2px $primary-red;
    p {
      font-size: 1.5rem !important;
    }
  }
  .form-end {
    border-top: solid 2px #bbb;
  }
  .input-td {
    text-align: center;
  }
  tr {
    th,
    td {
      height: 50px;
      position: relative;
      width: 25%;
      padding: 5px 10px;
      font-size: 1.2rem;
      line-height: 1.4rem;
      input {
        border: solid 1px $primary-red;
        text-align: center;
      }
      p {
        padding-top: 10px;
      }
    }
  }
}
.tr-header {
  border-top: solid 2px #777;
  line-height: 30px;
}
.tr-space {
  height: 50px;
}

.title-row {
  font-size: 1.5rem;
  position: absolute;
  top: -25px;
}

// .presupuesto-print {
//   padding: 10px 50px;
//   .title-print {
//     font-size: 30px;
//     margin-bottom: 10px;
//     margin-top: 10px;
//   }
//   .title-print-two {
//     font-size: 25px;
//     font-weight: bold;
//   }
//   img {
//     width: 100%;
//   }
//   .span-red {
//     color: $secondary-red !important;
//   }
//   .valor {
//     border: solid 1px $secondary-red;
//     text-align: center;
//     font-weight: bold;
//   }
//   .valor-total {
//     text-align: center;
//     font-weight: bold;
//     color: $secondary-red;
//   }
// }

// .form-calculadora {

//   .form-titles {
//     border-bottom: solid 2px #bbb;
//   }
//   .form-end {
//     border-top: solid 2px #bbb;
//   }
//   .input-td {
//     text-align: center;
//   }
//   tr {
//     th,
//     td {
//       height: 50px;
//       width: 25%;
//       padding: 5px 10px;
//       font-size: 1.2rem;
//       line-height: 1.4rem;
//       font-weight: normal;
//       input {
//         border: solid 1px $secondary-red;
//         text-align: center;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// FormCalculadoraPrintPatrimonio.vue?0ccb8e0d